import anime from 'animejs';

document.addEventListener('DOMContentLoaded', () => {
    const timelineComponent = document.getElementById('timeline-component');
    if (!timelineComponent) return;

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                animateTimeline();
                observer.unobserve(entry.target);
            }
        })
    }, { threshold: 0.25 });

    observer.observe(timelineComponent);
});

function animateTimeline() {
    const steps = document.querySelectorAll('.timeline-step');
    const __tl = anime.timeline({
        easing: 'easeOutExpo',
        duration: 600
    });

    steps.forEach((step, index) => {
        const _number = step.querySelector('.timeline-step__number');
        const _content = step.querySelector('.timeline-step__content');
        const _image = step.querySelector('.timeline-step__img');

        __tl.add({
            targets: _number, 
            translateY: [-30, 0],
            opacity: [0, 1]
        }, `+=${index === 0 ? 0 : 200}`)

        .add({
            targets: _content, 
            translateY: [-30, 0],
            opacity: [0, 1]
        }, '-=500')

        .add({
            targets: _image,
            opacity: [0, 1],
            duration: 500
        }, '-=400')
    });
}